import { CarouselFilterType, CarouselScreenValue, ScreenView } from "../../shared";

export function getScreen(selectedFilter: CarouselFilterType): CarouselScreenValue {
  return selectedFilter === 'experience' ? ScreenView.experienceCarousel 
    : selectedFilter === 'travelStyle' ? ScreenView.travelCarousel 
    : selectedFilter === 'activity' ? ScreenView.activitiesCarousel 
    : ScreenView.locationCarousel;
}
